import type { IconDef } from '../types';

export const dropdown: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M7.08796 9C6.66064 9 6.43024 9.50134 6.70853 9.82562L11.6273 15.5573C11.827 15.79 12.1872 15.7898 12.3866 15.5569L17.2936 9.82517C17.5713 9.50078 17.3408 9 16.9137 9L7.08796 9Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
